var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddressbook(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    stroke: "#ffffff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.195,31.517c1.128,0,2.042-0.897,2.042-1.996V23.61c0-1.102-0.914-2-2.042-2h-4.586v-1.603 c0-1.771-1.436-3.207-3.206-3.207H19.97c-1.771,0-3.206,1.435-3.206,3.207v59.986c0,1.766,1.436,3.206,3.206,3.206h53.432 c1.77,0,3.206-1.44,3.206-3.206v-1.67h4.586c1.128,0,2.042-0.894,2.042-1.996v-5.912c0-1.102-0.914-2-2.042-2h-4.586v-5.699h4.586 c1.128,0,2.042-0.894,2.042-1.991v-5.912c0-1.102-0.914-2-2.042-2h-4.586v-5.699h4.586c1.128,0,2.042-0.897,2.042-1.996v-5.912 c0-1.098-0.914-1.996-2.042-1.996h-4.586v-5.695H81.195z M62.391,63.681c0,1.152-0.804,2.088-1.795,2.088H32.75 c-0.992,0-1.795-0.935-1.795-2.088v-8.604c0-0.856,0.447-1.625,1.127-1.941l10.9-5.077c-2.583-1.557-4.351-4.689-4.351-8.304 c0-5.168,3.599-9.356,8.041-9.356c4.443,0,8.042,4.188,8.042,9.356c0,3.562-1.708,6.655-4.226,8.238l10.789,5.148 c0.674,0.325,1.115,1.085,1.115,1.937V63.681z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddressbook);
export default __webpack_public_path__ + "static/media/addressbook.0edca57a86ecb36db7601f8ba4890947.svg";
export { ForwardRef as ReactComponent };